import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cta: 'Confirm my information',
    section: 'Financial information',
    title: 'Your financial situation',
  },
  fr: {
    cta: 'Confimer mes informations',
    section: 'Informations fiscales',
    title: 'Votre situation fiscale',
  },
} as const);
